module.exports = __webpack_public_path__ + "static/media/icon-circle-dark.4e4dfb96.svg";